import React from "react";
import styles1 from "../Assets/css/boost.module.css";
import Board from "../Assets/img/Home/board.png";
import Group_7433 from "../Assets/img/Home/Group_7433.png";
import Group_7434 from "../Assets/img/Home/Group_7434.png";
import Group_7435 from "../Assets/img/Home/Group_7435.png";
import Group_7442 from "../Assets/img/Home/Group_7442.png";
import useMedia from "../componentsofcourse/useMedia";
//import Rectangle_1017 from "../Assets/img/Home/Rectangle 1017.png";
const MeetPartners = () => {
	//192.168.1.6
	const match = useMedia("(min-width : 800px )");
	//3000

	const fontFamily = {
		fontFamily: "Poppins-Bold",
	};

	return (
		<div>
			<div
				style={{
					backgroundColor: "#FAFAFA",
					marginBottom: "0px",
					paddingBottom: "0px",
				}}
				class="row"
			>
				<div
					style={{ marginBottom: "-6.05%", marginTop: "-7%" }}
					className="col-lg-3 col-xl-6 col-sm-12 col-md-12"
				>
					{match == true ? (
						<img
							style={{ marginLeft: "150px" }}
							width="220px"
							height="450px"
							src={Board}
							alt="board"
						/>
					) : null}
				</div>

				<div
					style={{ marginBottom: "0px" }}
					className="col-md-5 col-xl-6 col-sm-12 col-md-12"
				>
					<br />
					<br />
					<h5
						style={{ fontSize: "35px", textAlign: "left" }}
						className={styles1.Placement + " mt-3"}
					>
						Get Placed in Product companies
					</h5>
					<br />
					<div className="d-flex flex-row">
						<br />
						<a
							style={{
								textAlign: "center",
								padding: "10px",
								width: "220px",
								fontSize: "20px",
							}}
							href="/placementcourse"
							className=" btn btn-warning text-white"
						>
							Know more
						</a>
					</div>
					<br />
					<br />
					<br />
				</div>
			</div>

			<div
				className={`container-fluid ${styles1.boostcareer} pt-5 pb-5 pl-3 pr-3`}
			>
				<div className={styles1.rowHeight} class="row pb-5 ">
					<div
						style={{ marginBottom: "0px" }}
						class="col-xl-12 col-sm-12 p-4 text-center align-items-center"
					>
						<h1
							style={{
								textAlign: "left",
								wordSpacing: "17px",
								marginLeft: "16px",
							}}
						>
							<b>
								BOOST your <br /> career
							</b>{" "}
							<span style={{ fontSize: "4vh", color: "" }}>
								{" "}
								by{" "}
							</span>{" "}
						</h1>
					</div>
					<div className={`row ${styles1.rowboost}`}>
						<div
							style={{ marginLeft: "12px", marginRight: "12px" }}
							className={`col-xl-2 col-lg-3 col-md-3 ${styles1.part1}`}
						>
							<div>
								<img src={Group_7435} alt="" />
							</div>
							<div>
								<h4>
									<b>Learn</b>{" "}
								</h4>
								<p>
									Learn from{" "}
									<b style={fontFamily}>industry experts</b> &
									get Doubts clarified in less than{" "}
									<b style={fontFamily}>30min</b>{" "}
								</p>
							</div>
						</div>
						<div
							style={{ marginLeft: "12px", marginRight: "12px" }}
							className={`col-xl-2 col-lg-3 col-md-3 ${styles1.part2}`}
						>
							<div>
								<img src={Group_7434} alt="" />
							</div>
							<div>
								<h4>
									<b>Code</b>
								</h4>
								<p>
									Hands on <b style={fontFamily}>Project</b>{" "}
									based learning programs in a{" "}
									<b style={fontFamily}> community</b> based
									format
								</p>
							</div>
						</div>
						<div
							style={{ marginLeft: "12px", marginRight: "12px" }}
							className={`col-xl-2 col-lg-3 col-md-3 ${styles1.part3}`}
						>
							<div>
								<img src={Group_7433} alt="" />
							</div>
							<div>
								<h4>
									<b> Upskill</b>
								</h4>
								<p>
									Get <b style={fontFamily}>certified</b> ,
									Get <b style={fontFamily}>Internship</b>{" "}
									Land up in{" "}
									<b style={fontFamily}>dream job </b>{" "}
								</p>
							</div>
						</div>
						<div
							className={`col-xl-5 col-lg-3 col-md-3 ${styles1.boostimgdiv}`}
							style={{ marginBottom: "-2px" }}
						>
							<img
								style={{ width: "80%" }}
								className={styles1.boostimg}
								src={Group_7442}
								alt=""
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default MeetPartners;
